export default __webpack_public_path__ + "static/media/supper_apps_l1.cbc1ab8b.png";